import { useState } from "react";

export const useUserListRenderData = () => {
  const [showDeleteUserDrawer, setShowDeleteUserDrawer] = useState(false);
  const [deleteUserDetails, setDeleteUserDetails] = useState(null);

  const onDeleteUser = (user) => {
    setDeleteUserDetails(user);
    setShowDeleteUserDrawer(true);
  };

  const confirmDeleteUser = (user) => {
    // API call to delete user and refresh list
  };

  return {
    onDeleteUser,
    showDeleteUserDrawer,
    setShowDeleteUserDrawer,
    deleteUserDetails,
    confirmDeleteUser,
  };
};
